import * as React from 'react';

var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgEyeTest = function SvgEyeTest(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    "aria-hidden": "true",
    className: "eye-test_svg__icon eye-test_svg__icon--eye-test"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M2.25 1.5a.75.75 0 0 0-.75.75V4.5a.75.75 0 0 1-1.5 0V2.25A2.25 2.25 0 0 1 2.25 0H4.5a.75.75 0 1 1 0 1.5H2.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M12 9.375a2.625 2.625 0 1 0 0 5.25 2.625 2.625 0 0 0 0-5.25ZM10.875 12a1.125 1.125 0 1 1 2.25 0 1.125 1.125 0 0 1-2.25 0Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m20.12 11.577.004.007a.751.751 0 0 1 0 .832l-.005.007-.009.013-.03.045-.114.158a13.822 13.822 0 0 1-2.04 2.18c-1.38 1.182-3.422 2.431-5.926 2.431s-4.547-1.249-5.926-2.43a13.574 13.574 0 0 1-2.04-2.181l-.114-.158-.03-.045-.01-.013-.004-.007a.75.75 0 0 1 0-.832l.005-.007.009-.013.03-.045.114-.158a13.943 13.943 0 0 1 1.086-1.278l.173-.176.144-.144a14.809 14.809 0 0 1 .637-.582C7.454 7.999 9.496 6.75 12 6.75s4.547 1.249 5.926 2.43a13.4 13.4 0 0 1 1.611 1.637c.187.223.33.41.429.544l.114.158.03.045.01.013Zm-14.66.456L5.434 12l.026-.033.155-.19c.332-.398.819-.928 1.436-1.458C8.297 9.251 10.004 8.25 12 8.25s3.703 1.001 4.95 2.07c.616.529 1.103 1.06 1.435 1.457l.155.19.026.033-.026.033-.155.19c-.332.398-.819.928-1.436 1.458-1.246 1.068-2.953 2.069-4.949 2.069s-3.703-1.001-4.95-2.07a12.448 12.448 0 0 1-1.435-1.457l-.155-.19Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.784.525a.744.744 0 0 0 .102.656.75.75 0 0 0 .614.319h2.25a.75.75 0 0 1 .75.75V4.5a.75.75 0 0 0 1.5 0V2.25A2.25 2.25 0 0 0 21.75 0H19.5a.747.747 0 0 0-.716.525ZM.75 18.75a.75.75 0 0 1 .75.75v2.25c0 .414.336.75.75.75H4.5a.75.75 0 0 1 0 1.5H2.25A2.25 2.25 0 0 1 0 21.75V19.5a.75.75 0 0 1 .75-.75ZM24 19.5a.75.75 0 0 0-1.5 0v2.25a.75.75 0 0 1-.75.75H19.5a.75.75 0 0 0 0 1.5h2.25A2.25 2.25 0 0 0 24 21.75V19.5Z"
  })));
};

export { SvgEyeTest as default };
//# sourceMappingURL=eye-test.svg.js.map
